import { MutableRefObject, useEffect } from 'react';

export function useClickOutside(
  refOrSelector: MutableRefObject<HTMLElement | null> | string,
  onClickOutsideHandler: Function,
  deps?: boolean | string | number | Record<string, any>
): void {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const container =
        typeof refOrSelector === 'string'
          ? document.querySelector(refOrSelector)
          : refOrSelector.current;

      if (container && !container.contains(event.target as HTMLElement)) {
        onClickOutsideHandler();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [deps]);
}
